import type { AreaDict } from '../messages'

// Tela Comparativo (ComparisonPage): categorias x mês, estilo pivot (Lunch Money).
const comparison: AreaDict = {
  'pt-BR': {
    'cmp.title': 'Comparativo',
    'cmp.subtitle': 'Categorias x mês — lançado, sem projeção.',
    'cmp.thCategory': 'Categoria',
    'cmp.thTotal': 'Total',
    'cmp.thAverage': 'Média',
    'cmp.thCount': 'Qtd.',
    'cmp.rowTotal': 'Total',
    'cmp.rowAverage': 'Média',
    'cmp.noCategory': 'Sem categoria',
    'cmp.emptyTitle': 'Sem lançamentos no período',
    'cmp.emptyDesc': 'Escolha outro período ou lance transações para ver o comparativo.',
    'cmp.expand': 'Expandir subcategorias',
    'cmp.collapse': 'Recolher subcategorias',
  },
  en: {
    'cmp.title': 'Comparison',
    'cmp.subtitle': 'Categories x month — posted, no projection.',
    'cmp.thCategory': 'Category',
    'cmp.thTotal': 'Total',
    'cmp.thAverage': 'Average',
    'cmp.thCount': 'Count',
    'cmp.rowTotal': 'Total',
    'cmp.rowAverage': 'Average',
    'cmp.noCategory': 'Uncategorized',
    'cmp.emptyTitle': 'No transactions in this period',
    'cmp.emptyDesc': 'Pick another period or add transactions to see the comparison.',
    'cmp.expand': 'Expand subcategories',
    'cmp.collapse': 'Collapse subcategories',
  },
  es: {
    'cmp.title': 'Comparativo',
    'cmp.subtitle': 'Categorías x mes — registrado, sin proyección.',
    'cmp.thCategory': 'Categoría',
    'cmp.thTotal': 'Total',
    'cmp.thAverage': 'Promedio',
    'cmp.thCount': 'Cant.',
    'cmp.rowTotal': 'Total',
    'cmp.rowAverage': 'Promedio',
    'cmp.noCategory': 'Sin categoría',
    'cmp.emptyTitle': 'Sin movimientos en el período',
    'cmp.emptyDesc': 'Elige otro período o registra transacciones para ver el comparativo.',
    'cmp.expand': 'Expandir subcategorías',
    'cmp.collapse': 'Colapsar subcategorías',
  },
}
export default comparison
